import {
  ReleasesItems,
  ReleasesList,
  ReleasesSkeletonsItems,
  SmallReleasesItems,
  SmallReleasesList,
  SmallReleasesSkeletonsItems,
} from 'components/release-calendar/ReleasesList'
import { useInfinitePastReleases } from 'contexts'
import InfiniteScroll from 'react-infinite-scroll-component'

export function PastTab() {
  const {
    data: pastReleases,
    hasNextPage,
    fetchNextPage,
    isFetching,
  } = useInfinitePastReleases()

  return (
    <section className='mt-10 w-full px-6 pb-8 sm:mt-0 md:px-12'>
      <InfiniteScroll
        dataLength={pastReleases.totalItems}
        hasMore={Boolean(hasNextPage)}
        next={fetchNextPage}
        loader={null}
        className='mx-auto w-full max-w-[90rem] !overflow-hidden'
      >
        <ReleasesList>
          {pastReleases?.pages?.map((page, index) => (
            <ReleasesItems key={index} mappedReleases={page.mapped} />
          ))}

          {(isFetching || !pastReleases?.pages) && (
            <ReleasesSkeletonsItems count={18} shouldDisplayDate />
          )}
        </ReleasesList>

        <SmallReleasesList>
          {pastReleases?.pages?.map((page, index) => (
            <SmallReleasesItems key={index} mappedReleases={page.mapped} />
          ))}

          {(isFetching || !pastReleases?.pages) && (
            <SmallReleasesSkeletonsItems count={6} />
          )}
        </SmallReleasesList>
      </InfiniteScroll>
    </section>
  )
}
